import React, { useState, useRef } from "react";
import AuthInputField from "../ui/input/AuthInputs";
import images from "../../utils/images";
import authStyle from "../../style/layouts/auth.module.css";
import Step3ProfileStyle from "../../style/components/RegisterSteps/Step3ProfileInfo.module.css";
import mainstyle from "../../style/Main.module.css";

const Step3ProfileInfo = ({ formData, onChange, errors, setStepErrors }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const fileInputRef = useRef(null);

  const handleImageClick = () => {
    fileInputRef.current.click();
  };

  const handleImageUpload = (e) => {
    setStepErrors({});
    const file = e.target.files[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      onChange({
        target: {
          name: "emp_pic",
          value: null,
          error: "Please upload an image file",
        },
      });
      return;
    }

    // Preview for frontend
    const reader = new FileReader();
    reader.onloadend = () => {
      setSelectedImage(reader.result);
    };
    reader.readAsDataURL(file);

    // Store actual File object in formData
    onChange({
      target: {
        name: "emp_pic",
        value: file,
      },
    });
  };

  return (
    <div>
      <p>Your name helps others connect with you</p>
      <div className={Step3ProfileStyle.Step3ProfileInfoinputdiv}>
        <AuthInputField
          label="First Name"
          name="first_name"
          value={formData?.first_name || ""}
          onChange={onChange}
          required
          error={errors?.first_name}
        />

        <AuthInputField
          label="Last Name(Optional)"
          name="last_name"
          value={formData?.last_name || ""}
          onChange={onChange}
          error={errors?.last_name}
        />
      </div>

      <p>A photo makes your profile more welcoming.</p>

      <label>Profile (Optional)</label>
      <div className={authStyle.imageUploadViewauth}>
        <div
          onClick={handleImageClick}
          className={Step3ProfileStyle.Step3ProfileInfoinputdiv}
        >
          <img
            id="preview-image"
            src={selectedImage || images.userDemo}
            alt="Profile"
          />
        </div>
        <input
          type="file"
          accept="image/*"
          name="emp_pic"
          onChange={handleImageUpload}
          ref={fileInputRef}
          style={{ display: "none" }}
        />
      </div>

      {errors?.emp_pic && (
        <div className={authStyle.errorMessage}>{errors.emp_pic}</div>
      )}
      {errors?.error && (
        <div className={mainstyle.errorMsgCenter}>{errors.error}</div>
      )}

      <br />
    </div>
  );
};

export default Step3ProfileInfo;
